/**
 * Global Config
 */

import { z } from 'zod';

// Environment variable schema
const envSchema = z.object({
  VITE_API_URL: z.string().url('VITE_API_URL must be a valid URL'),
  VITE_S3_URL: z.string().url('VITE_S3_URL must be a valid URL'),
});

// Validate environment variables
const env = envSchema.parse({
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_S3_URL: import.meta.env.VITE_S3_URL,
});

const config = {};

// Domains
config.domains = {};
config.domains.api = env.VITE_API_URL;
config.domains.s3 = env.VITE_S3_URL;

// Log configuration in development
if (import.meta.env.DEV) {
  console.log('Widget Config:', {
    api: config.domains.api,
    s3: config.domains.s3,
    mode: import.meta.env.MODE
  });
}

export default config;
